import { useEffect, useState } from "react";
import axios from "axios";

// Relative path: works out of the box with Cloudflare Pages Functions
// (same domain, /api/* auto-routes to functions/api/*). If you deploy the
// Python FastAPI backend elsewhere instead, set REACT_APP_BACKEND_URL.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Fetches live CS2 stats (hours, K/D, HS%, map wins, weapon kills) from
 * our own backend, which proxies the Steam Web API (key never touches
 * the client). Falls back gracefully — the caller decides what to show
 * when `available` is false (missing credentials, private profile, etc).
 */
export default function useSteamStats() {
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/stats/csgo`, { timeout: 10000 });
        if (!cancelled) setState({ loading: false, data: res.data, error: null });
      } catch (err) {
        if (!cancelled) setState({ loading: false, data: null, error: err });
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
